export default __webpack_public_path__ + "static/pin-4ebba9880f4b8f5f63e3d17652d9ecab.svg";